module.exports = __webpack_public_path__ + "img/Riaz.fb2bf7bf.jpeg";